import CitySEOHead from "@/components/feature/CitySEOHead";
import DothanHeroSection from "./components/HeroSection";
import DothanStickyNav from "./components/StickyNav";
import DothanProcessingTimeSection from "./components/ProcessingTimeSection";
import DothanServicesSection from "./components/ServicesSection";
import DothanLocalAreaSection from "./components/LocalAreaSection";
import DothanTravelTimingSection from "./components/TravelTimingSection";
import DothanDestinationsSection from "./components/DestinationsSection";
import DothanTestimonialsSection from "./components/TestimonialsSection";
import DothanAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import DothanComparisonSection from "./components/ComparisonSection";
import DothanMistakesSection from "./components/MistakesSection";
import DothanHowItWorksSection from "./components/HowItWorksSection";
import DothanFAQSection, { faqs } from "./components/FAQSection";
import DothanHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import DothanFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function DothanPage() {
  return (
    <>
      <CitySEOHead
        city="Dothan"
        state="Alabama"
        stateAbbr="AL"
        route="/cities/dothan"
        title="Emergency Passport Dothan, AL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Dothan, AL — as fast as 24 hours. Serving Fort Novosel military families, Wiregrass agribusiness, and mission travelers. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Dothan, Alabama"
        geoPosition="31.2232;-85.3905"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Alabama"
        statePageRoute="/states/alabama"
        serviceAreaDesc="Emergency and expedited passport services for Dothan, Wiregrass, and Houston County, Alabama — as fast as 24 hours."
      />
      <div className="font-sans">
        <DothanHeroSection />
        <DothanStickyNav />
        <DothanProcessingTimeSection />
        <DothanLocalAreaSection />
        <DothanServicesSection />
        <DothanTravelTimingSection />
        <DothanDestinationsSection />
        <DothanTestimonialsSection />
        <DothanAcceptanceFacilitiesSection />
        <DothanComparisonSection />
        <DothanMistakesSection />
        <DothanHowItWorksSection />
        <DothanFAQSection />
        <DothanHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/dothan" state="AL" />
        <DothanFinalCTA />
      </div>
    </>
  );
}